export function toggleLoader(isLoading) {
  return dispatch => {
    dispatch({ type: 'TOGGLE_LOADER', isLoading })
  }
}
